import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const BackendOutageCard = () => {
  const navigate = useNavigate();
  const { retryBackendConnection } = useContext(AuthContext);
  const [retrying, setRetrying] = useState(false);

  const handleTryAgain = async () => {
    setRetrying(true);
    try {
      const ok = await retryBackendConnection?.();
      if (!ok) {
        window.location.reload();
      }
    } catch (_) {
      window.location.reload();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        maxWidth: '520px',
        width: '100%',
        background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%)',
        borderRadius: '24px',
        padding: '48px 40px',
        border: '1px solid rgba(251, 191, 36, 0.2)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(10px)',
        textAlign: 'center',
      }}>
        <div style={{
          width: '72px',
          height: '72px',
          margin: '0 auto 24px',
          background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.15) 0%, rgba(245, 158, 11, 0.15) 100%)',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid rgba(251, 191, 36, 0.3)',
          fontSize: '36px',
        }}>
          ⚠️
        </div>
        <h2 style={{
          fontSize: '1.75rem',
          fontWeight: 700,
          marginBottom: '12px',
          color: '#f1f5f9',
          letterSpacing: '-0.02em',
        }}>
          Service Temporarily Unavailable
        </h2>
        <p style={{
          fontSize: '0.95rem',
          color: '#94a3b8',
          lineHeight: 1.7,
          marginBottom: '16px',
        }}>
          We&apos;re having trouble connecting to our servers. Please try again in a few minutes.
        </p>
        <p style={{
          fontSize: '0.875rem',
          color: '#64748b',
          lineHeight: 1.7,
          marginBottom: '32px',
          padding: '12px 16px',
          background: 'rgba(255,255,255,0.03)',
          borderRadius: '10px',
          border: '1px solid rgba(255,255,255,0.06)',
        }}>
          Need to manage open positions or orders in the meantime?{' '}
          <a
            href="https://www.tradestation.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#fbbf24', textDecoration: 'none', fontWeight: 600 }}
            onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
            onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
          >
            Visit the official TradeStation website
          </a>
          {' '}to manage your account directly.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            onClick={handleTryAgain}
            disabled={retrying}
            style={{
              width: '100%',
              padding: '14px 24px',
              fontSize: '1rem',
              fontWeight: 600,
              color: '#0f172a',
              background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 14px rgba(251, 191, 36, 0.35)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(251, 191, 36, 0.45)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(251, 191, 36, 0.35)';
            }}
          >
            {retrying ? 'Checking…' : 'Try Again'}
          </button>
          <button
            onClick={() => navigate('/home')}
            style={{
              width: '100%',
              padding: '12px 24px',
              fontSize: '0.95rem',
              fontWeight: 600,
              color: '#94a3b8',
              background: 'transparent',
              border: '1.5px solid rgba(148, 163, 184, 0.3)',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(148, 163, 184, 0.08)';
              e.currentTarget.style.borderColor = '#94a3b8';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.3)';
            }}
          >
            Go to Home Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackendOutageCard;
